import { CAMPAIGN_TYPES } from '../constants/campaign';

export default {
  props: {
    campaignForceType: {
      type: String,
      default: null,
    },
  },
  computed: {
    defineCampaignType() {
      return this.campaignForceType || this.campaignType;
    },
    campaignType() {
      const pageURL = window.location.href;
      return pageURL.substring(pageURL.lastIndexOf('/') + 1);
    },
    isOngoingType() {
      return this.defineCampaignType === CAMPAIGN_TYPES.ONGOING;
    },
    isOnOffType() {
      return this.defineCampaignType === CAMPAIGN_TYPES.ONE_OFF;
    },
  },
};
